import React, { type ElementType } from 'react';
import { type MessageDescriptor, useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';

export const useFormattedMessageAndIcon = (message: MessageDescriptor, Icon: ElementType) => {
	const { formatMessage } = useIntl();

	const formattedMessage = formatMessage(message);
	const icon = fg('blu-8120_a11y_sidebar_menu_icons_remove_labels') ? (
		<Icon spacing="spacious" color="currentColor" aria-hidden="true" />
	) : (
		<Icon label={formattedMessage} spacing="spacious" color="currentColor" />
	);

	return { formattedMessage, icon };
};
